import {
  Overlay,
  ClosedInvoicesModalTabs,
  ErrorDisplay,
  Loader,
} from "src/components";
import { useCompany } from "src/store/slices/companySlice";
import { useCard } from "src/store/slices/cardsSlice";
import { cardConfig } from "src/utils/constants/CardConfig";
import { isModalDataEmpty, renderTestId } from "src/utils/HelperFunctions";
import { useGetModalQuery } from "src/store/serviceApi";

export interface Props extends React.HTMLAttributes<HTMLDivElement> {}

const CARD_ID = "d142537b-d201-4a9f-a89f-9fd1a1452ea2";
const MODAL_ID = cardConfig[CARD_ID].modalId;

const ClosedInvoicesModal: React.FC<Props> = ({}) => {
  const { company } = useCompany();
  const card = useCard(CARD_ID);

  const {
    data: modalData,
    isLoading,
    isFetching,
  } = useGetModalQuery({
    id: card?.modal ?? 0,
    companyId: company?.id ?? "",
  });

  if (!modalData) return null;

  return (
    <Overlay
      {...renderTestId(MODAL_ID)}
      className="md:min-w-[640px]"
      title={cardConfig[CARD_ID].modalTitle}
      id={MODAL_ID}
      variant="Overlay"
      updatedAt={new Date(modalData.updatedAt as string)}
      icon={cardConfig[CARD_ID].icon}
      size="xl"
    >
      {isLoading || isFetching ? (
        <Loader variant={"blue"} />
      ) : isModalDataEmpty(modalData.data) ? (
        <ErrorDisplay />
      ) : (
        <ClosedInvoicesModalTabs data={modalData} />
      )}
    </Overlay>
  );
};
export default ClosedInvoicesModal;
